export class MailRecipient {
    constructor(email: string | null, name: string | null) {
        this.email = email;
        this.name = name;
    }
    email: string | null;
    name: string | null;
}
